module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/nav//task.png?v=370fedcf";